<template>
  <div class="productSeries-box">
    <div v-for="(item,index) in seriesList" :key="index">
      <div class="productSeries-item" v-if="(index + 2)%2 == 0">
        <div class="itemTextLeft wow animate__animated animate__fadeInUp" data-wow-duration="2s">
          <div class="itemTextRight-box">
            <div class="name">{{item.name}}</div>
            <div class="productDesc">{{item.productDesc}}</div>
            <div class="btn_box" @click="goProductList(item.id)">{{$t('products.viewMore')}} ></div>
          </div>
        </div>
        <div class="itemImage wow animate__animated animate__fadeInDown" data-wow-duration="2s" style="overflow: hidden;">
          <img :src="item.coverProductURL" :alt="item.name">
        </div>
      </div>
      <div class="productSeries-item" v-else>
        <div class="itemImage wow animate__animated animate__fadeInUp" data-wow-duration="2s" style="overflow: hidden;">
          <img :src="item.coverProductURL" :alt="item.name">
        </div>
        <div class="itemTextRight wow animate__animated animate__fadeInDown" data-wow-duration="2s">
          <div class="itemTextRight-box">
            <div class="name">{{item.name}}</div>
            <div class="productDesc">{{item.productDesc}}</div>
            <div class="btn_box" @click="goProductList(item.id)">{{$t('products.viewMore')}} ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getProductSeriesList } from '@/api/editProducts'
export default {
  data () {
    return {
      seriesList: []
    }
  },
  mounted () {
    this.getProductSeriesList()
  },
  created () {
    document.documentElement.scrollTop = 0
  },
  methods: {
    // 获取产品系列列表数据
    getProductSeriesList () {
      getProductSeriesList().then(res => {
        if (res.code == 0) {
          this.seriesList = res.data
          this.refreshWow()
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    // 进入系列详细页面
    goProductList (id) {
      this.$router.push({ name: 'product-detail', params: { slug: id } })
    },
    refreshWow () {
      this.$nextTick(() => {
        if (this.$wow && this.$wow.element && typeof this.$wow.sync === 'function') {
          this.$wow.sync()
        } else if (this.$wow && typeof this.$wow.init === 'function') {
          this.$wow.init()
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.productSeries-box{
  min-height: 200px;
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  box-sizing: border-box;
  .productSeries-item{
    width: 100%;
    height: auto;
    margin-bottom: 40px;
    display: flex;
    gap: 0;
    .itemTextLeft{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      padding: 40px 25px;
      .itemTextRight-box{
        width: fit-content;
      }
    }
    .itemTextRight{
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      box-sizing: border-box;
      padding: 40px 25px 40px 0;
      .itemTextRight-box{
        width: fit-content;
      }
    }
    .name{
      font-size: clamp(28px, 5vw, 60px);
      word-break: break-word;
    }
    .productDesc{
      font-size: clamp(14px, 2vw, 18px);
      margin: 12px 0px;
      word-break: break-word;
    }
    .btn_box{
      font-size: 18px;
      text-decoration:underline;
      cursor: pointer;
    }
    .itemImage{
      flex: 1;
      min-height: 300px;
      overflow: hidden;
      aspect-ratio: 4 / 3;
      img{
        width: 100%;
        height: 100%;
        object-fit: contain;
      }
      img:hover{
        transform:scale(1.2);
      }
    }
  }
}

@media (max-width: 1199.98px) {
  .productSeries-box {
    padding: 0 15px;
  }
}

@media (max-width: 767.98px) {
  .productSeries-box {
    padding: 0 12px;

    .productSeries-item {
      flex-direction: column;
      margin-bottom: 24px;

      .itemTextLeft,
      .itemTextRight {
        flex: unset;
        width: 100%;
        padding: 20px 12px !important;
        justify-content: center;
      }

      .itemTextRight-box {
        width: 100%;
      }

      .itemImage {
        width: 100%;
        min-height: 200px;
      }
    }
  }
}
</style>
